import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'secondary' | 'quiet' | 'light'

type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonClassOptions {
    variant?: ButtonVariant
    size?: ButtonSize
    className?: string
}

const VARIANTS: Record<ButtonVariant, string> = {
    primary: 'bg-forest text-linen shadow-soft hover:bg-forest-deep',
    secondary: 'border border-ink/15 bg-linen text-ink hover:border-forest hover:text-forest',
    quiet: 'text-forest underline-offset-4 hover:text-forest-deep hover:underline',
    light: 'bg-linen text-forest-deep hover:bg-white'
}

const SIZES: Record<ButtonSize, string> = {
    sm: 'h-10 px-4 text-sm',
    md: 'h-12 px-6 text-[15px]',
    lg: 'h-14 px-7 text-base'
}

/**
 * Shared button look for `next/link`, `<a>` and `<button>` elements, so every call to action matches.
 */
export const buttonClass = ({ variant = 'primary', size = 'md', className }: ButtonClassOptions = {}): string => {
    return cn(
        'inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap transition-colors duration-200',
        'disabled:pointer-events-none disabled:opacity-60',
        variant === 'quiet' ? 'h-auto px-0' : SIZES[size],
        VARIANTS[variant],
        className
    )
}
